import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';
import PowerGrid from '../../ui/PowerGrid';

import DeleteAssetModal from './DeleteAssetModal';

import FileCell from './asset-form/FileCell';
import TagCell from '../tags/TagCell';
import RelationshipCell from './RelationshipCell';

const BooleanCell = ({ value }) => {
  if (value === true) return <span><span className="ti ti-check" /></span>;

  return <span />;
};

const actionColumn = (assetType, onDeleteClick) => ({
  key: '_id',
  text: '',
  noSort: true,
  renderBody: (data, _id) => {
    const handleDelete = () => onDeleteClick(_id);
    return (
      <div className="text-right">
        <Link
          className="btn btn-hollow-info btn-sm"
          to={`/pages/${assetType}/${_id}`}
        >
          Detail
        </Link>
      </div>
    );
  }
});

const tagsColumn = {
  key: 'tags',
  title: 'Tags',
  noSort: true,
  renderBody: (data, tags) => {
    const orderedTags = _.orderBy(tags || [], [
      tag => tag.color.toLowerCase(),
      tag => tag.value.toLowerCase()
    ]);
    return (
      <div>
        {(orderedTags || []).map(tag => <TagCell tag={tag} />)}
      </div>
    );
  }
};

const publishedColumn = {
  key: 'assetParent.published',
  title: 'Enabled',
  renderBody: data => {
    const { assetParent: { published } } = data || {};
    return <BooleanCell value={published} />;
  }
};

const versionColumn = {
  key: 'versionName',
  title: 'Published Version'
};

const getParams = match => {
  const { params } = match || {};
  return params;
};

const renderValue = (field, value) => {
  if (field.type === 'file') return <FileCell value={value} />;
  if (field.type === 'relationship')
    return <RelationshipCell field={field} value={value} />;
  if (field.type === 'boolean') return <BooleanCell value={value} />;
  if (field.type === 'select') {
    const { options, opts } = field || {};
    const { inputProps } = opts || {}
    const { multi } = inputProps || {};
    if (multi) {
      if (!Array.isArray(value)) return '';
      return (value || []).map(v => v.label).join(', ');
    } 
    const selected = (options || []).find(o => o.value === value) || {};
    return selected.label || value;
  }
  return value;
};

const getRowValue = (data = {}, name) => {
  const nameParts = (name || '').split('.');
  let r = Object.assign({}, data);
  for (var i = 0; i < nameParts.length; i++) {
    r = r[nameParts[i]];
    if (!r) return null;
  }
  return r;
};

class AssetList extends Component {
  constructor(props) {
    super(props);
    this.renderRowBody = this.renderRowBody.bind(this);
    this.loadPage = this.loadPage.bind(this);
    this.getTableColumns = this.getTableColumns.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.state = { deleting: null };
  }
  componentDidMount() {
    this.loadPage();
  }
  componentDidUpdate(prevProps) {
    const { type } = getParams(this.props.match);
    const { type: prevType } = getParams(prevProps.match);
    if (type !== prevType) this.loadPage();
  }
  loadPage() {
    const {
      match,
      getType,
      clearGetType,
      clearGetAssetsByType,
      getAssetsByType,
      getAllTypes
    } = this.props;
    const { params } = match || {};
    const { type } = params || {};
    clearGetAssetsByType();
    clearGetType();
    getAllTypes();
    if (!type) return;
    getType(type);
    getAssetsByType({ type });
  }
  renderRowBody(raw, v, c) {
    const { field, key, name } = c || {};
    const { opts, isAsset } = field || {};
    const row = getRowValue(raw, key);

    const {
      isArray
    } = opts || {};

    if (isArray && isAsset) {
      const { type } = this.props;
      const { fields } = type || {};
      const r = row instanceof Array ? row : [];
      const p = (fields || []).find(f => f.opts.name === name) || {};
      return r
        .map(s => {
          const f = (p.fields || []).find(t => t.opts.name === s.__type__) || {
          };
          return (f.opts || {}).label;
        })
        .join(', ');
    }

    if (isArray) {
      const r = row instanceof Array ? row : [];
      if (field.type === 'file') {
        return (
          <div>
            {r.map(r => renderValue(field, r))}
          </div>
        );
      }
      return r.join(', ');
    }

    if (isAsset) {
      return (
        <div>
          {opts.label}
        </div>
      );
    }

    return renderValue(field, row);
  }
  getTableColumns(fields = [], columnBase = 'data.') {
    const r = fields.reduce(
      (prev, f) => {
        const col = {
          key: columnBase + f.opts.name,
          name: f.opts.name,
          title: f.opts.label,
          renderBody: this.renderRowBody,
          field: f
        };
        if (!f.isAsset && f.opts.showInTable) {
          return [...prev, col];
        }
        const nextFields = this.getTableColumns(
          f.fields,
          `${columnBase}${f.opts.name}.`
        );
        if (f.opts.showInTable) {
          return [...prev, col, ...nextFields];
        }
        return [...prev, ...nextFields];
      },
      []
    );

    return r;
  }
  onDragStart(e, row) {
    this.dragging = row;
  }
  onDrop(e, row, index) {
    const { assets, updateDisplayOrder, clearUpdateDisplayOrder } = this.props;
    const { assetParent: sourceParent } = this.dragging || {};
    const { type } = getParams(this.props.match);

    if (!sourceParent) return;

    const temp = (assets || [])
      .map(({ assetParent }) => ({
        _id: assetParent._id,
        displayOrder: assetParent.displayOrder
      }))
      .filter(({ _id }) => _id !== sourceParent._id);

    temp.splice(index, 0, {
      _id: sourceParent._id,
      displayOrder: sourceParent.displayOrder
    });

    const payload = (temp || []).map(({ _id }, displayOrder) => ({
      _id,
      displayOrder
    }));

    clearUpdateDisplayOrder();
    updateDisplayOrder({ type, payload });
  }
  render() {
    const {
      type,
      assets,
      allTypes,
      inProgress,
      showModal,
      deleteAsset,
      deleteAssetErr,
      deleteAssetInProgress
    } = this.props;
    const { opts, fields, assetType } = type || {};
    const { label, name, helpText } = opts || {};
    const columns = this.getTableColumns(fields);

    if (inProgress) return false;

    const assetToDelete = (assets || [])
      .find(a => a._id === this.state.deleting);

    const onDeleteClick = _id => {
      this.setState({ deleting: _id });
      showModal('DeleteAssetModal');
    };

    const handleDeleteAsset = () => {
      if (!assetToDelete) return;
      deleteAsset(
        { id: assetToDelete.assetParentId },
        null,
        null,
        this.loadPage
      );
    };

    return (
      <div>
        <DeleteAssetModal
          assetToDelete={assetToDelete}
          handleDeleteAsset={handleDeleteAsset}
          deleteAssetErr={deleteAssetErr}
          deleteAssetInProgress={deleteAssetInProgress}
        />
        <div className="header">
          <div className="container-fluid">
            <h1>Pages</h1>
          </div>
        </div>
        <div className="container">
          <Row>
            <Col sm={4}>
              {(allTypes || []).map(a => {
                const {
                  opts,
                  assetType,
                  activeAsset
                } = a || {};
                const { _id } = activeAsset || {};
                if (opts.single)
                  return (
                    <Link
                      key={opts.name}
                      className="asset-item"
                      to={
                        _id
                          ? `/pages/${assetType}/${_id}`
                          : `/pages/${assetType}/create`
                      }
                    >
                      <div>
                        <div className="url">{opts.url || ''}</div>
                        <strong>{opts.label}</strong>
                        <em>View Details + Edit</em>
                      </div>
                    </Link>
                  );
                return (
                  <Link
                    key={opts.name}
                    className="asset-item"
                    to={`/pages/${assetType}`}
                  >
                    <div className="url">{opts.url || ''}</div>
                    <strong>{opts.label}</strong>
                    <em>View Details + Edit</em>
                  </Link>
                );
              })}
            </Col>
            <Col sm={8}>
              {type &&
                !opts.single &&
                <div>
                  <div>
                    <Link
                      to={`/pages/${assetType}/create`}
                      className="btn btn-sm btn-hollow-success add"
                    >
                      <span className="ti ti-plus" /> {label}
                    </Link>
                  </div>
                  <p className="list-note">{helpText}</p>
                  <PowerGrid
                    gridId={`assets-${name}`}
                    columns={[
                      versionColumn,
                      publishedColumn,
                      ...columns,
                      tagsColumn,
                      actionColumn(assetType, onDeleteClick)
                    ]}
                    rows={assets || []}
                    draggable
                    noSort
                    onDragStart={this.onDragStart}
                    onDrop={this.onDrop}
                  />
                </div>}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    result: type,
    error: typeErr,
    inProgress: getTypeInProgress
  } = state.getType.toJS();

  const {
    result: assets,
    error: assetsErr
  } = state.getAssetsByType.toJS();

  const {
    result: allTypes,
    error: allTypesErr
  } = state.getAllTypes.toJS();

  const {
    error: deleteAssetErr,
    inProgress: deleteAssetInProgress
  } = state.deleteAsset.toJS();

  const error = typeErr || assetsErr || allTypesErr;

  const inProgress = getTypeInProgress;

  return {
    type,
    allTypes,
    assets,
    error,
    inProgress,
    deleteAssetErr,
    deleteAssetInProgress
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getType: fetchDux.getType.createAction,
      clearGetType: fetchDux.getType.clearAction,
      getAssetsByType: fetchDux.getAssetsByType.createAction,
      clearGetAssetsByType: fetchDux.getAssetsByType.clearAction,
      getAllTypes: fetchDux.getAllTypes.createAction,
      deleteAsset: fetchDux.deleteAsset.createAction,
      clearDeleteAsset: fetchDux.deleteAsset.clearAction,
      updateDisplayOrder: fetchDux.updateDisplayOrder.createAction,
      clearUpdateDisplayOrder: fetchDux.updateDisplayOrder.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(AssetList);



// WEBPACK FOOTER //
// ./src/components/routes/assets/AssetList.js